<template>
  <div class="page-dialog">
    <!-- 查询条件 -->
    <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
    
    <!-- 数据表格 -->
    <div class="table-container">
      <TableCommon
        :custome-config="() => vxeShowCustom('gridOptions')"
        :show-header="false"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="medium"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiSetShuntingFindByCustomerWithFilter } from '@/api/applyForGoods/index'
import pageConfig, { pageSearch } from './config/ShuntDealerSelect'

export default {
  props: {
    queryParams: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      conditions: {
        customerCode: '',
        type: 2
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 50 }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      allConditions: {}
    }
  },
  computed: {},
  created() {
    if (this.queryParams !== null) {
      Object.assign(this.conditions, this.queryParams)
    } else {
      this.conditions.customerCode = this.$store.getters.role.USER_BP
    }
    this.initPage(pageConfig)
  },
  methods: {
    initPage(pageConfig) {
      const columns = []
      const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += 'TextView'
        }
        columns.push(obj)

        if (pageConfig[key].type) {
          searchField[key] = pageConfig[key]
        }
      })

      if (Object.keys(this.pageSearch).length) {
        Object.assign(this.pageSearch, searchField)
        this.searchField = this.pageSearch
      } else {
        this.searchField = searchField
      }
      this.gridOptions.columns = this.gridOptions.columns.concat(columns)
    },
    
    // QueryParams组件需要的方法
    resetCount() {
      // 弹窗组件不需要计算行，空实现即可
    },
    
    // 处理QueryParams组件的查询参数
    handleRanges(ranges) {
      const conditions = {}
      Object.keys(ranges).forEach(key => {
        if (ranges[key] && ranges[key].length > 0) {
          conditions[key] = ranges[key]
        }
      })
      this.allConditions = conditions
    },
    
    cellClick({ row }) {
      this.$refs.gridOptions.setRadioRow(row)
    },
    
    // 查询
    async queryData(page, ranges) {
      if (ranges) {
        // 保存查询组件的查询参数
        this.handleRanges(ranges)
      }
      
      // 构建查询参数
      const params = {
        customerCode: this.conditions.customerCode,
        ...this.allConditions
      }
      
      // 自动为编号和名称添加*号进行模糊查询
      if (params.shuntingCustomer && params.shuntingCustomer.length > 0) {
        params.shuntingCustomer = params.shuntingCustomer.map(item => {
          if (item.low && !item.low.includes('*')) {
            return { ...item, low: `*${item.low}*` }
          }
          return item
        })
      }
      
      if (params.shuntingCustomerName && params.shuntingCustomerName.length > 0) {
        params.shuntingCustomerName = params.shuntingCustomerName.map(item => {
          if (item.low && !item.low.includes('*')) {
            return { ...item, low: `*${item.low}*` }
          }
          return item
        })
      }

      this.loading = true
      try {
        const { data } = await apiSetShuntingFindByCustomerWithFilter(params)
        
        if (data && data.setShuntingDetailList) {
          this.gridOptions.data = data.setShuntingDetailList
        } else {
          this.gridOptions.data = []
        }
      } catch (error) {
        console.error('查询失败', error)
        this.$message.error(error.message || '查询失败，请稍后重试')
        this.gridOptions.data = []
      } finally {
        this.loading = false
      }
    },
    
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        const selectData = this.$refs.gridOptions.getRadioRecord()
        if (!selectData) {
          this.$message.warning('请选择一条数据')
          resolve(null)
          return
        }
        resolve(selectData)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-dialog {
  padding: 10px;
}

.table-container {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/ShuntDealerSelect.vue